import React, { memo, useState } from 'react';
import { useSocket } from '../contexts/SocketContext';
import { trackDonationEvent } from '../utils/analytics';
import './LiveCount.css';

const LiveCount = memo(() => {
  const { isConnected, clientCount } = useSocket();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Use a minimum count of 5 if no data or disconnected
  const displayCount = clientCount > 0 ? clientCount : 5;

  const openModal = () => {
    trackDonationEvent('Donation Modal Opened', { label: 'LiveCount Widget' });
    setIsModalOpen(true);
  };
  const closeModal = () => {
    trackDonationEvent('Donation Modal Closed', { label: 'LiveCount Widget' });
    setIsModalOpen(false);
  };

  return (
    <div className="live-count-container">
      <div className="live-count-card">
        <div className="live-count-header">
          <h3>Where Two or Three are Gathered in My Name, I Am in Their Midst</h3>
          <p className="bible-verse">Matthew 18:15-20</p>
        </div>
        
        <div className="live-count-display">
          <div className="count-number">
            {displayCount}
          </div>
          <div className="count-label">
            Praying Now
          </div>
        </div>
        
        <div className="connection-status">
          <div className={`status-indicator ${isConnected ? 'connected' : 'disconnected'}`}>
            <span className="status-dot"></span>
            <span className="status-text">
              {isConnected ? 'Live' : 'Demo Mode'}
            </span>
          </div>
        </div>
        
        <div className="donation-section">
          <button 
            className="donate-button" 
            onClick={openModal}
            style={{
              background: 'rgb(118, 75, 162)', 
              color: 'rgb(255, 255, 255)', 
              border: 'none',
              fontFamily: 'Verdana, sans-serif', 
              display: 'flex', 
              gap: '8px', 
              width: 'fit-content', 
              fontSize: '16px', 
              borderRadius: '5px', 
              lineHeight: '24px', 
              padding: '8px 24px',
              margin: '1rem auto 0',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
            }}
          >
            <img src="https://donorbox.org/images/white_logo.svg" alt="Donorbox" style={{ width: '20px', height: '20px' }} />
            Donate
          </button>
        </div>
      </div>

      {/* Donation Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Support World Rosary</h2>
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <iframe 
                src="https://donorbox.org/embed/world-rosary?" 
                name="donorbox" 
                allowpaymentrequest="allowpaymentrequest" 
                seamless="seamless" 
                frameBorder="0" 
                scrolling="no" 
                height="900px" 
                width="100%" 
                style={{
                  maxWidth: '500px', 
                  minWidth: '250px', 
                  maxHeight: 'none !important',
                  border: 'none',
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                }} 
                allow="payment"
                title="Donorbox Donation Form"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

LiveCount.displayName = 'LiveCount';

export default LiveCount;
